<template>

<router-view :key="$route.fullPath" />

</template>

<script>
export default {
	name: '',
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
</style>
